import React from "react";
 export const Details=()=>{
    return(
        <h1>Details</h1>
    )
 }